module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n    <div class="m-modal-column"></div>\n\n\n     <div class="m-modal-section" >\n         <div class="m-modal-section__title">Select a preset</div>\n         <div class="m-modal-column">\n             <div class="form-group">\n                 <select class="form-control js-preset-select" name="type">\n                     <option value="">Choose...</option>\n                     ';
 _.each(getPresetList(), function(value){ 
__p+='\n                        <option value="'+
((__t=( value._id ))==null?'':__t)+
'" >'+
((__t=( value.name ))==null?'':__t)+
'</option>\n                     ';
 }); 
__p+='\n                 </select>\n             </div>\n         </div>\n    </div>\n\n\n    <div class="m-modal-section" >\n        <div class="m-modal-section__title">Real-time dimlevel control</div>\n        <div class="m-modal-column">\n            <div class="form-group">\n                <label for="name">Channel</label>\n                <select class="form-control js-channel" >\n                    <option value="1" selected>1</option>\n                    <option value="2">2</option>\n                    <option value="3">3</option>\n                    <option value="4">4</option>\n                    <option value="5">5</option>\n                    <option value="6">6</option>\n                    <option value="7">7</option>\n                    <option value="8">8</option>\n                    <option value="9">9</option>\n                    <option value="10">10</option>\n\n                  <!-- ';
 _.each(getRgbColors(), function(value) { 
__p+='\n                    <option value="'+
((__t=( value.hex ))==null?'':__t)+
'">'+
((__t=( value.label ))==null?'':__t)+
'</option>\n                  ';
 }); 
__p+=' -->\n                </select>\n            </div>\n        </div>\n        <div class="m-modal-row">\n            <div class="form-group">\n                <label for="name">Change DIM level</label>\n                <div>\n                  ';
 _.each(getDimLevels(), function(value){ 
__p+='\n                    <a class="m-btn js-dimlevel" data-dimlevel="'+
((__t=( value ))==null?'':__t)+
'">'+
((__t=( value ))==null?'':__t)+
'%</a>\n                  ';
 }); 
__p+='\n                </div>\n            </div>\n        </div>\n    </div>\n\n\n\n        \n\n    ';
 _.each([0,1,2,3,4,5,6,7,8,9], function(value) { 
__p+='\n        \n    <div class="m-modal-section no-bottom-padding" >\n        <div class="m-modal-section__title">'+
((__t=( getAttribute('settings.composerLabels.attributes.label_'+(value+1), 'Composer '+ (value+1)) ))==null?'':__t)+
' </div>\n    </div>\n    <div class="routine__region-dali_'+
((__t=( value + 1 ))==null?'':__t)+
'"></div>\n\n    ';
 }); 
__p+='\n\n\n\n\n\n\n    <div class="m-modal-section__full m-day-routine" >\n        <div class="m-routine-composer js-routine-composer"></div>\n    </div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/devices/control/templates/control-dali-x.html
// module id = 431
// module chunks = 0